<template>
  <div class="body-form">
    <Loading v-if="isLoading" />
    <Popup :message="message" v-if="isPopup" @close="() => (isPopup = false)" />
    <div style="width: 90%; margin: 30px 0;">
      <div class="menus-top">
        <span class="blue-text" @click="$router.go(-1)">Corporate Training</span>
        <Arrow :width="20" :height="20" direct="left" strokeColor="#7B7E8C" class="icon" />
        <span style="color: #7b7e8c">{{ name }}</span>
      </div>
      <div class="card-form-head">
        <h1>Form {{ name }}</h1>
      </div>

      <div class="tab-selector" v-if="isEdit || isWatch">
        <button
          :class="['tab', activeTab === 'id' ? 'active-tab' : '']"
          @click="activeTab = 'id'"
        >
          Bahasa Indonesia
        </button>
        <button
          :class="['tab', activeTab === 'en' ? 'active-tab' : '']"
          @click="activeTab = 'en'"
        >
          Bahasa Inggris
        </button>
      </div>

      <div v-if="activeTab === 'id'" class="language-section">
        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Bahasa Indonesia</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Kategori</p>
              <v-select
                :disabled="isWatch"
                class="form-input"
                :items="categories"
                :item-text="'name'"
                :item-value="'value'"
                v-model="form.category"
                placeholder="Pilih kategori"
                solo
              ></v-select>
            </div>
            <div class="content-form">
              <p>Title</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="form.title"
                class="form-input"
                placeholder="Tulis Judul"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Description</p>
              <v-textarea
                :disabled="isWatch"
                outlined
                v-model="form.description"
                class="form-input"
                placeholder="Tulis Deskripsi"
                dense
                clearable
              ></v-textarea>
            </div>
            <div class="content-form mb-5">
              <p>Scope Learning</p>
              <div class="scope-learning-item">
                <div
                  style="display: flex; gap: 10px; flex-wrap: wrap;"
                  v-for="(data, idx) in form.scope_learning"
                  :key="idx"
                >
                  <v-text-field
                    :disabled="isWatch"
                    outlined
                    v-model="form.scope_learning[idx].name"
                    class="form-input no-space"
                    dense
                    placeholder="Enter scope learning"
                    style="max-width: 290px"
                  ></v-text-field>
                  <Button
                    name="-"
                    width="40px"
                    height="35px"
                    title="Remove Scope Learning"
                    @click="() => form.scope_learning.splice(idx, 1)"
                    outline
                    v-if="form.scope_learning.length > 1 && !isWatch"
                  />
                </div>
              </div>
              <Button
                name="+"
                width="40px"
                height="35px"
                title="Add Scope Learning"
                v-if="!isWatch"
                @click="() => form.scope_learning.push({ name: '' })"
              />
            </div>
          </div>
        </div>
      </div>

      <div v-if="activeTab === 'en'" class="language-section">
        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Bahasa Inggris</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Title</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="formEng.title"
                class="form-input"
                placeholder="Enter Title"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Description</p>
              <v-textarea
                :disabled="isWatch"
                outlined
                v-model="formEng.description"
                class="form-input"
                placeholder="Enter Description"
                dense
                clearable
              ></v-textarea>
            </div>
            <div class="content-form mb-5">
              <p>Scope Learning</p>
              <div class="scope-learning-item">
                <div
                  style="display: flex; gap: 10px; flex-wrap: wrap;"
                  v-for="(data, idx) in formEng.scope_learning"
                  :key="idx"
                >
                  <v-text-field
                    :disabled="isWatch"
                    outlined
                    v-model="formEng.scope_learning[idx].name"
                    class="form-input no-space"
                    dense
                    placeholder="Enter scope learning"
                    style="max-width: 290px"
                  ></v-text-field>
                  <Button
                    name="-"
                    width="40px"
                    height="35px"
                    title="Remove Scope Learning"
                    @click="() => formEng.scope_learning.splice(idx, 1)"
                    outline
                    v-if="formEng.scope_learning.length > 1 && !isWatch"
                  />
                </div>
              </div>
              <Button
                name="+"
                width="40px"
                height="35px"
                title="Add Scope Learning"
                v-if="!isWatch"
                @click="() => formEng.scope_learning.push({ name: '' })"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="submit-box" v-if="!isWatch">
        <Button
          name="Batalkan"
          outline
          class="me-3"
          @click="$router.push('/corporate-training')"
        />
        <Button
          :name="isEdit ? 'Simpan' : 'Simpan & Publish'"
          :width="isEdit ? '156px' : '200px'"
          @click="onSubmit"
          :disabled="!validData"
          style="background-color: #2d46cf; color: #ffffff"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/ilustration/Loading.vue";
import Button from "@/components/Button.vue";
import Popup from "@/components/others/Popup.vue";
import Arrow from "@/components/icons/Arrow.vue";

export default {
  name: "FormCorporateTraining",
  components: {
    Button,
    Popup,
    Loading,
    Arrow,
  },
  computed: {
    validData() {
      return (
        this.form.title &&
        this.form.description &&
        this.form.category &&
        this.form.scope_learning.some((item) => item.name)
      );
    },
  },
  data() {
    return {
      id: null,
      name: "",
      isLoading: false,
      isWatch: false,
      isEdit: false,
      message: "",
      isPopup: false,
      activeTab: "id",
      categories: [
        { name: "General", value: "GENERAL" },
        { name: "Certified", value: "CERTIFIED" },
      ],
      form: {
        title: "",
        description: "",
        scope_learning: [{ name: "" }],
        category: "",
      },
      formEng: {
        title: "",
        description: "",
        scope_learning: [{ name: "" }],
      },
    };
  },
  methods: {
    checkingType() {
      this.name = this.$route.meta.name;
      this.isWatch = this.$route.path.lastIndexOf("watch") >= 0;
      this.isEdit = this.$route.path.lastIndexOf("edit") >= 0;
      this.id = this.$route.params.id;
      if (!this.id) return;
      this.getDataCT();
    },
    async getDataCT() {
      this.isLoading = true;
      try {
        const resp = await this.$crm_http.get("/v1/corporate-training/" + this.id);
        const data = resp.data.data;
        this.form = {
          title: data.title || "",
          description: data.description || "",
          scope_learning: typeof data.scope_learning === "string"
            ? JSON.parse(data.scope_learning)
            : data.scope_learning || [{ name: "" }],
          category: data.category || "",
          id: data.id,
        };
        await this.getBilingual();
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to load data.";
        this.isPopup = true;
      } finally {
        this.isLoading = false;
      }
    },
    async getBilingual() {
      try {
        const { data } = await this.$crm_http.get(
          `/v1/bilingual/record/${this.id}?table_name=corporate_training&language_code=en`
        );
        const resp = JSON.parse(data.data.bilingual?.translated_data || "{}");
        this.formEng = {
          title: resp.title || "",
          description: resp.description || "",
          scope_learning: resp.scope_learning || [{ name: "" }],
        };
      } catch (err) {
        console.log(err);
      }
    },
    async onSubmit() {
      this.isLoading = true;
      try {
        const payload = {
          title: this.form.title,
          description: this.form.description,
          scope_learning: this.form.scope_learning.map((item) => ({
            name: item.name,
          })),
          category: this.form.category,
        };

        if (this.isEdit) {
          await this.$crm_http.put("/v1/corporate-training/" + this.form.id, payload);
          await this.onSubmitBilingual();
        } else {
          await this.$crm_http.post("/v1/corporate-training", payload);
        }

        setTimeout(() => {
          this.$router.push("/corporate-training");
        }, 2000);
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to submit data.";
        this.isPopup = true;
        this.isLoading = false;
      }
    },
    async onSubmitBilingual() {
      const payload = {
        table_name: "corporate_training",
        record_id: this.id,
        language_code: "en",
        translated_data: JSON.stringify({
          title: this.formEng.title,
          description: this.formEng.description,
          scope_learning: this.formEng.scope_learning.map((item) => ({
            name: item.name,
          })),
          category: this.form.category,
        }),
      };
      try {
        await this.$crm_http.post("/v1/bilingual", payload);
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted() {
    this.checkingType();
  },
};
</script>

<style scoped>
.menus-top {
  padding-top: 10px;
  display: flex;
  font-size: 16px;
  gap: 8px;
  align-items: center;
  margin-bottom: 10px;
}
.card-form-head {
  display: flex;
  margin: 40px 0;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
}
.card-form-head-2 {
  display: flex;
  margin-left: -35px;
  margin-right: -20px;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid gray;
}
.card-form-head-2 h1 {
  font-weight: 700;
  font-size: 18px;
  color: #36373f;
  font-family: 'Poppins', sans-serif;
  margin: 0;
}
.tab-selector {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 50px;
}
.tab {
  padding: 10px 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  cursor: pointer;
  background-color: #f9f9f9;
}
.active-tab {
  background-color: #2d46cf;
  color: white;
  border-color: #2d46cf;
}
.body-form {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fafaf9;
  padding-bottom: 30px;
  min-height: 100vh;
}
.cart-form {
  position: relative;
  margin: 40px 0;
  border-radius: 30px;
  padding: 30px 40px;
  background-color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
}
.language-section {
  margin-bottom: 30px;
}
.content-form {
  margin-top: 15px;
}
.content-form p {
  font-size: 14px;
  margin: 3px 0;
  font-weight: bold;
}
.form-input {
  border-radius: 14px !important;
  background-color: transparent !important;
}
.form-input:focus {
  border-color: #2d46cf;
  box-shadow: 0 0 5px rgba(45, 70, 207, 0.3);
}
.scope-learning-item {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(2, 1fr);
}
.submit-box {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}
.blue-text {
  font-weight: bold;
  color: #162ca2;
  cursor: pointer;
}
</style>